import React, { useEffect, useRef } from 'react';
import ReactPlayer from 'react-player';
import { Box } from '@mui/material';

const VideoPlayer = ({ videoUrl }) => {
	const playerRef = useRef(null);

	useEffect(() => {
		if (playerRef.current && videoUrl) {
			playerRef.current.load?.();
		}
	}, [videoUrl]);

	return (
		<Box
			className="video-box"
			sx={{
				position: 'relative',
				paddingTop: '56.25%',
				backgroundColor: 'black', // black screen background
			}}
		>
			{videoUrl && (
				<ReactPlayer
					ref={playerRef}
					src={videoUrl}
					controls
					width="100%"
					height="100%"
					style={{ position: 'absolute', top: 0, left: 0 }}
				/>
			)}
		</Box>
	);
};

export default VideoPlayer;
